import { Component, OnInit, ViewChildren, QueryList, ViewChild, HostListener } from '@angular/core';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIURLRegisterService } from '../../_services/url-register/API-urlregister';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { map } from 'rxjs/operators';
import { saveAs as importedSaveAs } from "file-saver";
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router, ActivatedRoute } from '@angular/router';

const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);

@Component({
  selector: 'app-url-register-list',
  templateUrl: './url-register-list.component.html',
  styleUrls: ['./url-register-list.component.css']
})
export class UrlRegisterListComponent implements OnInit {
  maxDate: Date = new Date();
  filterData: any;
  dataSource: MatTableDataSource<any>;
  noRecord: any;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();  
  @ViewChild('tSort') sort: MatSort;
  //  @ViewChild(MatSort) sort: MatSort;

  form1: any = {};

  dataSubject = new BehaviorSubject<any[]>([]);

  // displayedColumns: string[] = ['urn', 'url', 'type', 'lurl', 'status', 'peRemarks', 'regRemarks', 'approver', 'Created_Date']
  displayedColumns: string[] = ['urn', 'ctaType', 'ctaSubType', 'ctaValue', 'status', 'peRemarks', 'regRemarks', 'approver', 'apkFilename', 'Created_Date']
  fetchedData: any;
  data: any = {};
  pageNo: number = 1;
  pageSize: number = 5;
  showStatusDropdown: boolean = false;
  entityName: any;
  entityId: any;

  constructor(
    private urlApi: APIURLRegisterService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private _route: ActivatedRoute,
  ) { 
    this._route.params.subscribe((params) => {

      this.entityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
      this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    });
  }

  ngOnInit() {
    this.data = {
      "Start_Date": "",
      "End_Date": "",
      "filterType": "",
      "param": "",
      "EntityID": this.entityId
    }
    this.APIgetUrlSummary(this.data);
  }

  openDropdown(value) {
    this.showStatusDropdown = false
    if (value == "Status") {
      this.showStatusDropdown = true;
    }
  }
  
  onChangeDataSource(value) {

    this.dataSource = new MatTableDataSource(value.message);
    //console.log("------------------values" + this.dataSource);
    this.dataSource.paginator = this.paginator.toArray()[0];
   // console.log("values" + value);
    //this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }

  APIgetUrlSummary(data) {
    this.urlApi.urlRegisterList(data)
      .subscribe(r => {
        this.fetchedData = JSON.stringify(r);
        this.dataSource = r;
        this.onChangeDataSource(r);
      });
   
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  download(urn, file1, folder) {
    var data = {
      Ref_No: urn,
      Folder: folder,
      FileName: file1,
    };
    this.urlApi.downloadUrlblobFile(data).subscribe((r) => {
      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: " URL Whitelist By PE",
        msg: "File has been downloaded Successfully",
      });
    });
  }

  enddateError = false
  addEvent(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.enddateError = false;
    }
  }
  addEventEnddate(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.enddateError = true;
    }
  }

  reset() {
    this.data = {
      Start_Date: "",
      End_Date: "",
      filterType: "",
      param: "",
      EntityID: this.entityId,
    };
    this.form1.searchBy1 = null
    this.APIgetUrlSummary(this.data);
  }

  onSubmitFilter(filterForm, form) {

    //console.log("filterForm", filterForm);
    //console.log("hi !!!");
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.searchBy
    
    //console.log("-------param----------", param)
    // var param = filterForm.search
    if (typeof param === 'undefined' || param == null)
      param = "";

    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;

    if (filterForm.searchBy1)
      param = filterForm.searchBy1;
    //console.log("-------param-----srch1-----", param)

    if (filterForm.search)
      param = filterForm.search;
    //console.log("-------param----srch------", param)

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    //console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)

    if (fdate != "" && ldate == "") {
      ldate = cdate
    }

    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,
      "param": param,
      "EntityID": this.entityId

    }

    if (fdate == "" && ldate == "" && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }
    else {

      this.APIgetUrlSummary(this.data)
    }
  }

  downloadUrlListCSV() {
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530'); 
    this.urlApi.downloadUrlWorklistFile(this.data).subscribe(r => {  
    var fileName = currentdat + ' urlSummaryForPe.csv';  
    importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'whitelisting Summary for PE',
        msg: 'File has been downloaded Successfully'
      });   
    });
  }

}
